import { Fragment } from 'react';

import { DetailedView } from './DetailedView';
import { TableRowContent } from './TableRowContent';
import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { SONSTIGE_VERBINDLICHKEITEN, type SONSTIGE_VERBINDLICHKEITEN_TYPE } from '../../../types';
import { useExpandedItem } from '../../context/ExpandedItemContext';
import { TableRow } from '../shared/TableRow';

type Props = {
    credit: SchemaCreditRequestForm[SONSTIGE_VERBINDLICHKEITEN_TYPE][number];
    index: number;
    toggleRefinance: (index: number) => void;
    toggleHide: (index: number) => void;
};

export const SonstigeVerbindlichkeit = ({ credit, index, toggleHide, toggleRefinance }: Props) => {
    const { isExpanded, toggleItem } = useExpandedItem();
    const itemId = `${SONSTIGE_VERBINDLICHKEITEN}.${index}` as const;

    const showDetailedView = isExpanded(itemId);

    return (
        <Fragment key={credit.id}>
            <TableRow credit={credit} tableContentRow onClick={() => toggleItem(itemId)}>
                <TableRowContent
                    credit={credit}
                    index={index}
                    showDetailedView={showDetailedView}
                    toggleHide={toggleHide}
                    toggleRefinance={toggleRefinance}
                />
            </TableRow>
            {showDetailedView && (
                <TableRow credit={credit}>
                    <DetailedView credit={credit} index={index} />
                </TableRow>
            )}
        </Fragment>
    );
};
